// GlobalStateContext.js
import { createContext, useState } from "react";

const GlobalStateContext = createContext();

export const GlobalStateProvider = ({ children }) => {
  const [globalState, setGlobalState] = useState({
    // Initial state global states
    showSignupModal: false,
    showClaimFundsModal: false,
    showConfirmPledgeModal: false,
    selectedView: "View"
  });

  return (
    <GlobalStateContext.Provider value={{ globalState, setGlobalState }}>
      {children}
    </GlobalStateContext.Provider>
  );
};

export default GlobalStateContext;